import { type ReactNode } from 'react';

import styles from './ButtonBadge.module.css';

type Props = { children: ReactNode; ariaLabel?: string };

export function ButtonBadge(props: Props) {
  return (
    <span aria-hidden={props.ariaLabel ? undefined : true} className={styles.badge} aria-label={props.ariaLabel}>
      <span className={styles.content}>{props.children}</span>
    </span>
  );
}
